import React, { useState } from 'react';
import CouponCodesAdminList from './components/CouponCodesAdminList';
import CouponCodesAdminAdd from './components/CouponCodesAdminAdd';
import { Box, Tabs, Tab } from '@mui/material';

const CouponCodesAdminPage: React.FC = () => {
  const [tab, setTab] = useState(0);

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs value={tab} onChange={handleTabChange} aria-label="Global Coupon Codes admin tabs">
        <Tab label="List Global Coupon Codes" />
        <Tab label="Insert Global Coupon Code" />
      </Tabs>
      <Box sx={{ mt: 2 }}>
        {tab === 0 && <CouponCodesAdminList />}
        {tab === 1 && <CouponCodesAdminAdd />}
      </Box>
    </Box>
  );
};

export default CouponCodesAdminPage;
